export type ChatToolContext = "companion" | "ile";
export type ToolId = "guidedLearning" | "quizMe" | "deepResearch" | "createImage" | "createILE";

export interface ToolOption {
  id: ToolId;
  label: string;
}

const COMPANION_TOOLS: ToolOption[] = [
  { id: "deepResearch", label: "toolsMenu.deepResearch" },
  { id: "createImage", label: "toolsMenu.createImage" },
  { id: "createILE", label: "toolsMenu.createILE" },
];

export const TOOL_OPTIONS_BY_CHAT_TYPE: Record<ChatToolContext, ToolOption[]> = {
  companion: COMPANION_TOOLS,
  ile: [],
};
